import type { Dictionnaire } from '../type';

export const profil: Dictionnaire['profil'] = {
  erreurs: {
    compteIntrouvable: 'Cuenta no encontrada',
    membreIntrouvable: 'Miembro no encontrado',
    pseudoPris: 'Este nombre de usuario ya está cogido',
    spotIntrouvable: 'Spot no encontrado',
    bientot: (spot: string) => `${spot} abre pronto, ¡no te lo pierdas!`,
    prive: (spot: string) => `${spot} está reservado a sus miembros.`,
  },
  aideErreurs: {
    vide: 'Cuéntanos qué pasa',
  },
  commun: {
    changerPhoto: 'Cambiar mi foto de perfil',
    mesDestinations: 'Mis destinos',
    mesPosts: 'Mis publicaciones',
    mesEvenements: 'Mis eventos',
    mesAmis: 'Mis amigos',
    mesSignets: 'Mis guardados',
    voirTout: 'Ver todo',
    notePar: (note: string, n: number) =>
      `Valorado con ${note} sobre 5 por ${n} participante${n === 1 ? '' : 's'}`,
    personnaliser: 'Personalizar mi perfil',
    bio: 'Bio',
    debloquer: 'Desbloquear',
    membresBloques: 'Miembros bloqueados',
    visibilite: 'Visibilidad del perfil',
    parametres: 'Ajustes',
    aide: 'Ayuda y denuncias',
    ajouterAmis: 'Añadir amigos',
    ecrireA: (nom: string) => `Escribir a ${nom}`,
  },
  compte: {
    photoMiseAJour: 'Foto actualizada.',
    photoRetiree: 'Foto quitada.',
    photoImpossible: 'No se ha podido guardar la foto',
    enregistre: 'Perfil guardado.',
    impossible: 'No se ha podido guardar',
    enregistrer: 'Guardar',
    retirerPhoto: 'Quitar mi foto',
    pseudo: 'Nombre de usuario',
    bioExemple: 'Dos líneas sobre ti, lo que buscas aquí...',
    langues: 'Idiomas que hablas',
    languesAide: 'Las salidas en tus idiomas aparecen primero en la lista.',
  },
  masques: {
    titre: 'Ocultos y bloqueados',
    comptesMasques: 'Cuentas ocultas',
    comptesBloques: 'Cuentas bloqueadas',
    postsMasques: 'Publicaciones ocultas',
    afficher: 'Dejar de ocultar',
    impossible: 'No es posible por el momento.',
    comptes: {
      personne: 'Ninguna cuenta oculta',
      personneAide: 'Puedes ocultar una cuenta desde su perfil, con los tres puntos de arriba a la derecha.',
      explication: 'Ya no ves sus publicaciones ni sus salidas. No lo saben, y nada más cambia entre vosotros.',
      masque: 'Oculta',
    },
    posts: {
      aucun: 'Ninguna publicación oculta',
      aucunAide: 'Las publicaciones que ocultas desde el feed aparecen aquí.',
    },
  },
  bloques: {
    impossible: 'No se puede desbloquear ahora mismo.',
    personne: 'No hay nadie bloqueado',
    personneAide: 'Puedes bloquear a un miembro desde su perfil, con los tres puntos de arriba a la derecha.',
    explication: 'Sus publicaciones y sus eventos ya no te aparecen, y vuestras conversaciones quedan ocultas.',
    bloque: 'Bloqueado',
  },
  destinations: {
    villes: 'Ciudades',
    actuel: 'Servidor actual',
    changer: 'Cambiar de servidor',
  },
  amis: {
    aucun: 'Todavía no tienes amigos',
    aucunAide: 'Te esperan las sugerencias del servidor y las solicitudes recibidas.',
    trouver: 'Encontrar miembros',
  },
  aide: {
    impossible: 'No se puede enviar ahora mismo.',
    envoyer: 'Enviar',
    intro: 'Cuéntanos qué pasa. Nuestro equipo lo lee todo y te responde por correo.',
    sujet: '¿De qué se trata?',
    raconte: 'Cuéntanoslo',
    raconteExemple: 'Qué ha pasado, dónde y con quién, si es el caso.',
    sujets: {
      member: 'Un miembro',
      event: 'Un evento',
      content: 'Una publicación o un mensaje',
      bug: 'Un problema técnico',
      other: 'Otra cosa',
    },
  },
  membre: {
    ami: {
      none: 'Añadir como amigo',
      requested: 'Solicitud enviada',
      incoming: 'Aceptar la solicitud',
      friends: 'Quitar de amigos',
    },
    ceMembre: 'este miembro',
    profil: 'Perfil',
    refuserQ: '¿Rechazar su solicitud de amistad?',
    refuser: 'Rechazar su solicitud de amistad',
    debloquerMembre: 'Desbloquear a este miembro',
    bloquerMembre: 'Bloquear a este miembro',
    masquerCompte: 'Ocultar esta cuenta',
    nePlusMasquer: 'Dejar de ocultar esta cuenta',
    estMasque: (nom: string) => `Has ocultado a ${nom}. Ya no verás sus publicaciones ni sus eventos.`,
    plusMasque: (nom: string) => `Ya no ocultas a ${nom}.`,
    ecrire: 'Escribirle',
    tuAsBloque: 'Has bloqueado a este miembro',
    tuAsBloqueAide: 'Sus publicaciones ya no aparecen en tu feed, y ya no te sugerimos a esta persona.',
    officiel: 'Es la cuenta del equipo de Sirocco. Escríbele para cualquier pregunta.',
    reserve: 'Perfil reservado a sus amigos',
    reserveAide: 'Envíale una solicitud de amistad para ver sus publicaciones.',
    sesDestinations: 'Sus destinos',
    sesEvenementsMasques: 'Sus eventos están ocultos por sus ajustes.',
    demandeRefusee: (nom: string) => `Solicitud de ${nom} rechazada.`,
    debloque: (nom: string) => `Has desbloqueado a ${nom}.`,
    bloquerQ: (nom: string) => `¿Bloquear a ${nom}?`,
    bloque: (nom: string) => `Has bloqueado a ${nom}. Ya no puede enviarte mensajes ni solicitudes de amistad.`,
    retirerAmiQ: (nom: string) => `¿Quitar a ${nom} de tus amigos?`,
    plusAmi: (nom: string) => `${nom} ya no es tu amigo.`,
    appeler: (nom: string) => `Llamar a ${nom}`,
    avis: (n: string) => (n === '1' ? '· 1 opinión' : `· ${n} opiniones`),
  },
  notifications: {
    choix: {
      messages: 'Mensajes',
      appels: 'Llamadas',
      amis: 'Solicitudes de amistad',
      postsAmis: 'Publicaciones de mis amigos',
      evenements: 'Eventos',
      acceptee: 'Participación aceptada',
      inscriptions: 'Inscripciones a mis eventos',
      desinscriptions: 'Bajas de mis eventos',
      reactions: 'Reacciones a mis publicaciones',
      mentions: 'Menciones',
    },
    titre: 'Notificaciones',
  },
  motDePasse: {
    troisConditions: 'Esta contraseña no cumple las tres condiciones',
    pasIdentiques: 'Las dos contraseñas no coinciden',
    impossible: 'No se ha podido cambiar',
    titre: 'Correo y contraseña',
    changer: 'Cambiar mi contraseña',
    actuel: 'Contraseña actual',
    nouveau: 'Nueva contraseña',
    confirmer: 'Confirmar la nueva contraseña',
    envoye: 'Correo enviado',
    lienRecu: (email: string) => `Abre el enlace recibido en ${email} para elegir una nueva contraseña.`,
  },
  ecran: {
    modifier: 'Editar mi perfil',
    mesEvenementsSorties: 'Mis eventos y salidas',
  },
  visibilite: {
    intro: 'Elige lo que ven los demás miembros del servidor cuando abren tu perfil.',
    quiPeutVoir: 'Quién puede ver mi perfil',
    toutLeServeur: 'Todo el servidor',
    amisSeulement: 'Solo mis amigos',
    ceQuiApparait: 'Lo que aparece en mi perfil',
    evenementsAide: 'Los demás ven en qué participo',
    mesDestinationsAide: 'Las ciudades por las que he pasado',
    postsAide: 'Visibles desde mi perfil',
    enLigne: 'Estado en línea',
    enLigneAide: 'Punto verde en mi avatar',
    destinationsAmis: 'Mis destinos solo para amigos',
    destinationsAide: 'Las ciudades por las que he pasado, solo para mis amigos',
    messages: 'Mensajes',
  },
  tableau: {
    mois: 'Últimos 30 días',
    posts: 'posts',
    tenues: 'eventos celebrados',
    presences: 'asistencias',
    inscriptions: 'Registros por semana',
    cetteSemaine: 'esta semana',
    ilYaSemaines: (n: number) => `hace ${n} sem.`,
    nInscriptions: (n: number) => (n === 1 ? '1 registro' : `${n} registros`),
    fidelite: 'Fidelidad',
    revenus: 'vuelven tras su primera semana',
    encoreActifs: 'siguen activos tras un mes',
    surN: (n: number, sur: number) => `${n} de ${sur}`,
    pasAssez: 'aún no hay suficiente perspectiva',
    parServeur: 'Por servidor',
    serveurLigne: (membres: number, actifs: number) =>
      `${membres} miembro${membres === 1 ? '' : 's'} · ${actifs} activo${actifs === 1 ? '' : 's'} esta semana`,
    serveurDetail: (posts: number, tenues: number, presences: number, aVenir: number) =>
      `${posts} post${posts === 1 ? '' : 's'} (7 d) · ${tenues} evento${tenues === 1 ? '' : 's'} y ${presences} asistencia${presences === 1 ? '' : 's'} (30 d) · ${aVenir} próximo${aVenir === 1 ? '' : 's'}`,
    sansServeur: 'sin servidor',
    titre: 'Panel',
    actifsAujourdhui: 'activos hoy',
    semaine: 'esta semana',
    comptes: 'cuentas',
    nouveaux: 'nuevos (7 d)',
    unSignalement: '1 denuncia espera una decisión',
    connexions: 'Últimas conexiones',
    versions: 'Versiones instaladas',
    unCompte: '1 cuenta',
    sorties: 'Próximas salidas',
    rien: 'Nada previsto por ahora.',
    spontanee: 'espontánea',
    jamais: 'nunca',
    depuis: {
      minutes: (n: number) => `hace ${n} min`,
      heures: (n: number) => `hace ${n} h`,
      jours: (n: number) => `hace ${n} d`,
    },
    build: (n: string) => ` · build ${n}`,
    signalements: (n: number) => `${n} denuncias esperan una decisión`,
    nComptes: (n: number) => `${n} cuentas`,
  },
  reglages: {
    apparences: {
      system: 'Automático',
      day: 'Claro',
      night: 'Oscuro',
    },
    apparenceAide: {
      system: 'Sigue el ajuste de tu teléfono.',
      day: 'Siempre claro, sea cual sea el teléfono.',
      night: 'Siempre oscuro, sea cual sea la hora.',
    },
    deconnexionImpossible: 'No se ha podido cerrar la sesión. Vuelve a intentarlo.',
    suppressionImpossible: 'No se ha podido borrar',
    compte: 'Cuenta',
    emailEtMotDePasse: 'Correo electrónico y contraseña',
    serveur: 'Servidor / destino',
    confidentialite: 'Privacidad',
    coupees: 'Desactivadas en los ajustes del teléfono',
    moderation: 'Moderación',
    tableau: 'Panel',
    administration: 'Administración',
    application: 'Aplicación',
    apparence: 'Apariencia',
    langue: 'Idioma',
    deconnecterQ: '¿Cerrar sesión?',
    deconnecter: 'Cerrar sesión',
    supprimerQ: '¿Borrar definitivamente tu cuenta? Se borrarán tus publicaciones y tus mensajes.',
    supprimer: 'Borrar mi cuenta',
  },
};
